import React from 'react';

import { useDeleteDatasetGroup } from 'api/api-hooks/dataset-groups-hooks';
import { GroupButtonProps } from 'api/model/dataset/datasetGroups';
import { Button } from 'primereact/button';
import { confirmPopup } from 'primereact/confirmpopup';
import { T } from 'services/lang/LanguageService';

const DeleteGroupButton: React.FC<GroupButtonProps> = ({ group }) => {
  const { mutateAsync } = useDeleteDatasetGroup();

  const confirmDelete = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    confirmPopup({
      target: e.currentTarget,
      message: T("confirm-popup.are-you-sure-you-want-to-delete-this-group"),
      icon: 'pi pi-exclamation-triangle',
      acceptClassName: 'p-button-danger',
      accept: async () => {
        await mutateAsync(group!);
      }
    })
  }
  return (
    <Button
      label={T("action.delete-group")}
      icon="pi pi-trash"
      className="component-editor-button icon-red"
      disabled={!group}
      onClick={confirmDelete}
    />
  );
}

export default DeleteGroupButton